import { usePathname } from "hooks/path-hooks";
import { useEffect, useState } from "react";
import { ArrowLeft } from "static/images/svgs/arrow-left";
import { ArrowRight } from "static/images/svgs/arrow-right";
import { CustomizedBack } from "store/navigation-wrapper";
import { isGuid } from "utils/data-type-check";
import translate from "utils/translations";

const BreadCrumb = () => {
  const currentLocale = localStorage.getItem("language") || "ar";
  const [headerArray, setHeaderArray] = useState<string[]>([]);
  const pathname = usePathname();
  useEffect(() => {
    const pathArray = pathname
      .trim()
      .split("/")
      .filter((header) => {
        return !isGuid(header);
      })
      .filter((header) => {
        return header !== "";
      });
    setHeaderArray(pathArray);
  }, [window.location.pathname]);
  const translateHeader = (header: string) => {
    if (header.includes("-")) {
      return translate(
        `${header
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join("_")}_Text`,
        header
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join("_"),
      );
    }
    return translate(
      `${header
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join("_")}_Text`,
      header
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join("_"),
    );
  };
  const renderBreadCrump = () => {
    return headerArray.map((header, index) => {
      return (
        <div className="bg-white">
          <ul className=" flex text-xl text-[#2E4053] items-center">
            <li
              onClick={() =>
                index === 0 && headerArray.length > 1 ? CustomizedBack() : null
              }
              className={
                index === 0 && headerArray.length > 1
                  ? "p-4 cursor-pointer"
                  : "p-4"
              }
            >
              {translateHeader(header)}
            </li>
            {index !== headerArray.length - 1 &&
              (currentLocale === "ar" ? (
                <ArrowLeft width={7} height={12} strokeColor="#1D2433A6" />
              ) : (
                <ArrowRight width={7} height={12} strokeColor="#1D2433A6" />
              ))}
          </ul>
        </div>
      );
    });
  };
  return (
    <div className={"flex space-x-4 items-center font-medium"}>
      {renderBreadCrump()}
    </div>
  );
};

export { BreadCrumb };
